var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget"},[(_vm.isMobile)?_c('RegionsMobile'):_c('div',{staticClass:"widget-body-wrapper"},[_c('div',{staticClass:"d-flex flex-direction-row h-100"},[_c('Map'),_c('regions-list')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }